import { fetchAuth } from './authService';

const API = process.env.REACT_APP_API_URL;

export async function getDocuments() {
  const res = await fetchAuth(`${API}/documents`);
  if (!res.ok) throw new Error('Failed to load documents.');
  const data = await res.json();
  return {
    documents:        data.documents        ?? data,
    ingestionStatus:  data.ingestionStatus  ?? null,
    ingestionAllowed: data.ingestionAllowed ?? true,
    docTrainings:     data.docTrainings     ?? null,
  };
}

async function sha256Hex(file) {
  const buffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
  return 'sha256-' + Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0')).join('');
}

export async function getUploadUrls(files) {
  const filesWithHash = await Promise.all(
    files.map(async f => ({
      fileName: f.name,
      fileType: f.type,
      fileSize: f.size,
      fileHash: await sha256Hex(f),
      product: 'pulse',
    }))
  );
  const res = await fetchAuth(`${API}/documents/upload-url`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ files: filesWithHash }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to get upload URLs.');
  return { files: data.files || [], errors: data.errors || [] };
}

// S3 presigned URL — no auth header
export async function uploadToS3(uploadUrl, file) {
  const res = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });
  if (!res.ok) throw new Error(`S3 upload failed for ${file.name}`);
}

export async function markReady(docId) {
  const res = await fetchAuth(`${API}/documents/${docId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ status: 'ready_to_ingest' }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to mark document ready.');
  return data;
}

export async function ingestDocuments() {
  const res = await fetchAuth(`${API}/ingest`, { method: 'POST' });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to start ingestion.');
  return data;
}

export async function bulkDeleteDocuments(docIds) {
  const res = await fetchAuth(`${API}/documents`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ docIds }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to delete documents.');
  return data;
}
